import React from 'react';
import { store } from '@/Store/configureStore';
import { selectors } from '@/Store';

/**
 * Gets a label string from the labels config in Redux store.
 */
export const getLabelConfigMessage = (key: string): string => {
  const { getState } = store;
  const labelsConfig = selectors.auth.labelsConfig(getState() || {});
  return labelsConfig[key] ?? `${key} not found`;
};

/**
 * Replaces \n characters with JSX <br/> elements.
 */
const replaceLineBreaks = (text: string): JSX.Element => {
  return (
    <>
      {text.split('\\n').map((line, index, arr) => (
        // eslint-disable-next-line react/no-array-index-key
        <React.Fragment key={index}>
          {line}
          {index < arr.length - 1 && <br />}
        </React.Fragment>
      ))}
    </>
  );
};

/**
 * Retrieves a label, optionally interpolates values, and returns as string or JSX.
 */
const getLabel = (
  labelKey: string,
  values?: { [key: string]: string },
  shouldReturnJSX = false,
) => {
  let label = getLabelConfigMessage(labelKey);
  if (values) {
    Object.keys(values).forEach(key => {
      label = label.replaceAll(`{${key}}`, values[key]);
    });
  }

  return shouldReturnJSX ? replaceLineBreaks(label) : label;
};

export default getLabel;
